import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/aktivnote/note',
	title:       'menu.aktivnote',
	// redirectTo:  '/front5/aktivnote',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/aktivnote/note';
	},
});
